export enum DeliveryMethod {
    HOME_DELIVERY = 2,
    PICK_UP_IN_STORE = 1,
}